/* ============================================================
   FX rates — fallback / static values
   ============================================================
   These are used when:
   - Live rates haven't loaded yet
   - The frankfurter.app API is down
   - Code paths that don't have access to the FxContext
   
   For LIVE rates, use the useFxRates() hook from useFxRates.jsx.
   ============================================================ */

export const FX_RATES = {
  JPY_TO_BRL: 0.039,
  JPY_TO_USD: 0.0065,
  USD_TO_BRL: 5.85,
  BRL_TO_JPY: 25.6,
  updated: "2026-05-16",
  source: "fallback",
};

/* ============================================================
   Cost-of-living factors (relative to Tokyo = 1.0)
   ============================================================
   Rough estimates for purchasing-power comparison.
   For production, consider Numbeo CPI data refreshed quarterly.
   ============================================================ */

export const COL = {
  tokyoBaseline: 1.0,
  jpAverage: 0.78,
  jpSmallCity: 0.72,
  spSaoPaulo: 0.46,
  rj: 0.48,
  brSmallCity: 0.32,
};

/**
 * Convert JPY income to equivalent BRL purchasing power in target city.
 * Pass a live `jpyToBrl` rate when available; otherwise falls back to FX_RATES.
 */
export function jpyToBrlPurchasingPower(
  jpyAmount,
  {
    fromMultiplier = COL.jpAverage,
    toMultiplier = COL.spSaoPaulo,
    jpyToBrl = FX_RATES.JPY_TO_BRL,
  } = {}
) {
  return (jpyAmount * jpyToBrl * fromMultiplier) / toMultiplier;
}
